export const useGroupPairing = (attributes = [], taskType, filterDuplicates = false) => {
    if (attributes.length === 0) {
        return [];
    }

    const consumed = new Set();

    return attributes
        .filter(({ hiddenAttributeTaskInfo }) => {
            return hiddenAttributeTaskInfo === null || (hiddenAttributeTaskInfo && hiddenAttributeTaskInfo.every((type) => type !== taskType));
        })
        .reduce((pairedAttributes, attribute, _index, filteredAttributes) => {
            if (consumed.has(attribute.uuid) && filterDuplicates) {
                return pairedAttributes;
            }

            const [pairedAttributeParams] = attribute.pairedAttributes;

            if (!pairedAttributeParams) {
                return [...pairedAttributes, [attribute]];
            }

            const isAttributePaired = pairedAttributes.some((attributePair) =>
                attributePair.some(({ uuid }) => {
                    return pairedAttributeParams.uuid === uuid;
                })
            );

            if (isAttributePaired) {
                return pairedAttributes;
            }

            const pair = filteredAttributes.find(({ uuid }) => uuid === pairedAttributeParams.uuid);

            if (!pair) {
                return [...pairedAttributes, [attribute]];
            }

            if (filterDuplicates) {
                consumed.add(pair.uuid);
            }

            return [...pairedAttributes, [attribute, pair]];
        }, []);
};
